import { lazy } from 'react'

export const ActivateUserAsync = lazy(() => import('./ActivateUser')
    .then((module) => ({ default: module.ActivateUser }))
)
